var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { ViscaBase } from './util/ViscaBase';
export class ViscaTcp extends ViscaBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(ViscaTcp.driverType, state, log, framework);
        this.socket = socket;
    }
    // controls
    // phase callbacks
    // other class methods
    registerAsync(match, callback, name) {
        return this.socket.registerAsync({ match, callback, name });
    }
    send(bytes, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.socket.send(AsciiText.decode(bytes), match, tags, options);
        });
    }
    setIdleTimeoutMs(timeoutMs) {
        this.socket.setIdleTimeoutMs(timeoutMs);
    }
}
// static properties
ViscaTcp.driverType = 'socketDriver';
ViscaTcp.key = '-LLzon5kEJ0cTR0z4DFm';
ViscaTcp.socketOptions = (config) => {
    var _a;
    return [
        {
            commandExtractor: {
                terminators: ['\xff'],
            },
            isBinary: true,
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 4999,
            sendTerminator: '\xff',
        },
    ];
};
